import { Permission } from '@common/permissions';
import React, { useEffect } from 'react';
import { useSession } from 'src/apps/invest/common/hooks/useSession';
import { useInboxModel } from '../../../../common/models/InboxModel';
import { useInvestorAccountModel } from '../../../../common/models/InvestorAccountModel';
import { usePermissions } from '../../common/hooks/usePermissions';
import { ROUTES } from '../../config';
import { InboxView } from '../views/Inbox';
import { Agreement } from '../views/alerts/Agreement';
import { DwollaTerms } from '../views/alerts/DwollaTerms';
import { VerifyEmail } from '../views/alerts/VerifyEmail';
import { MessageDetails } from '../views/messages/MessageDetails';

const sessionRedirect = ROUTES.inbox;
const permissions: Permission[] = ['ACCREDITED_INVESTOR', 'UNACCREDITED_INVESTOR'];

type InboxControllerProps = {
  page: 'AGREEMENT' | 'DWOLLA_TERMS' | 'LIST' | 'VERIFY_EMAIL' | 'MESSAGE';
};

export const InboxController: React.FC<InboxControllerProps> = ({ page }) => {
  const { checkAuthenticated } = useSession();
  const { checkPermissions } = usePermissions();

  const inboxModel = useInboxModel();
  const investorAccountModel = useInvestorAccountModel();

  const init = async () => {
    if (!(await checkAuthenticated(sessionRedirect))) return;
    if (!(await checkPermissions(permissions))) return;

    const investorAccount =
      investorAccountModel.investorAccount ??
      (await investorAccountModel.fetchInvestorAccount()).investorAccount ??
      null;

    inboxModel.checkForAlerts(investorAccount);
    inboxModel.checkForMessages();
    inboxModel.checkForIntercomMessages();
  };

  useEffect(() => {
    init();
  }, []);

  switch (page) {
    case 'LIST':
      return <InboxView />;
    case 'VERIFY_EMAIL':
      return <VerifyEmail />;
    case 'AGREEMENT':
      return <Agreement />;
    case 'DWOLLA_TERMS':
      return <DwollaTerms />;
    case 'MESSAGE':
      return <MessageDetails />;
  }
};
